// Widgets

Vue.component(
    'submit-button',
    require('./components/widgets/SubmitButtonComponent.vue')
);

Vue.component(
    'custom-icon',
    require('./components/widgets/CustomIconComponent.vue')
);

Vue.component(
    'mobile-main-menu',
    require('./components/widgets/MobileMainMenuComponent.vue')
);

Vue.component(
    'main-menu',
    require('./components/widgets/MainMenuComponent.vue')
);

Vue.component(
    'loader',
    require('./components/widgets/LoaderComponent.vue')
);

Vue.component(
    'meeting-invite-form',
    require('./components/widgets/MeetingInviteForm.vue')
);

Vue.component(
    'get-country-domain',
    require('./components/widgets/GetCountryDomain.vue')
)

// Vue.component(
//     'registration-contact-overlay',
//     require('./components/widgets/RegistrationContactOverlay.vue')
// );

// End Widgets

// Registration

Vue.component(
    'registration-profile-button',
    require('./components/registration/Profile/button.vue')
);
Vue.component(
    'registration-profile-slider',
    require('./components/registration/Profile/slider.vue')
);
Vue.component(
    'registration-profile-legs',
    require('./components/registration/Profile/legs.vue')
);
Vue.component(
    'registration-profile-plane-picture',
    require('./components/registration/Profile/plane-picture.vue')
);
Vue.component(
    'registration-profile-plane-info-flight',
    require('./components/registration/Profile/plane-info-flight.vue')
);
Vue.component(
    'registration-profile-form',
    require('./components/registration/Profile/form.vue')
);
Vue.component(
    'registration-profile-mobile-form',
    require('./components/registration/Profile/formMobile.vue')
);
Vue.component(
    'registration-profile-data-form',
    require('./components/registration/Profile/formData.vue')
);
Vue.component(
    'registration-profile-simple-form',
    require('./components/registration/Profile/formSimple.vue')
);
Vue.component(
    'registration-validate-phone-form',
    require('./components/registration/Profile/formValidatePhone.vue')
);

Vue.component(
    'registration-step-indicator',
    require('./components/registration/StepIndicatorComponent.vue')
);

Vue.component(
    'select-service',
    require('./components/registration/SelectServiceComponent.vue')
);

Vue.component(
    'registration-form-password',
    require('./components/registration/PasswordFormComponent.vue')
);

Vue.component(
    'resend-email-user-create',
    require('./components/registration/ResendEmailUserCreateComponent.vue')
);

// End Registration


// Registration Other

Vue.component(
    'registration-other-form-profile',
    require('./components/registration-other/ProfileComponent.vue')
);


// End Registration Other

// Forms

Vue.component(
    'payment-form',
    require('./components/PaymentFormComponent.vue')
);

Vue.component(
    'contact-form',
    require('./components/ContactFormComponent.vue')
);

Vue.component(
    'job-candidature-form',
    require('./components/JobCandidatureComponent.vue')
);

// End Forms

// Other

Vue.component(
    'airport-input',
    require('./components/widgets/AirportInputComponent.vue')
);

Vue.component(
    'cookies-info',
    require('./components/CookiesInfo.vue')
);

Vue.component(
    'airports-map',
    require('./components/AirportsMap.vue')
);

Vue.component(
    'airport-map',
    require('./components/AirportMap.vue')
);

Vue.component(
    'validate-contract',
    require('./components/ValidateContract.vue')
);

Vue.component(
    'home-steps-screen',
    require('./components/HomeStepsScreen.vue')
);

Vue.component(
    'home-testimonials',
    require('./components/HomeTestimonials.vue')
);
Vue.component(
    'pilots-requirements',
    require('./components/PilotsRequirements.vue')
);
Vue.component(
    'video-modal',
    require('./components/VideoModal.vue')
);
Vue.component(
    'home-steps-screen-carousel',
    require('./components/HomeStepsScreenCarousel.vue')
);
Vue.component(
    'passenger-feedback-carousel',
    require('./components/PassengerFeedbackCarousel.vue')
);
Vue.component(
    'rating',
    require('./components/Rating.vue')
);
Vue.component(
    'rating-star',
    require('./components/RatingStar.vue')
);
Vue.component(
    'offers-cards',
    require('./components/OffersCards.vue')
);
Vue.component(
    'insurance-faq',
    require('./components/InsuranceFaq.vue')
);
Vue.component(
    'aero4good-footer-link',
    require('./components/Aero4goodFooterLink.vue')
);
Vue.component(
    'ecology-plane-comparison',
    require('./components/EcologyPlaneComparison.vue')
);
Vue.component(
    'newsletter-registration-form',
    require('./components/NewsletterRegistrationForm.vue')
);
Vue.component(
    'owner-income-simulator',
    require('./components/OwnerIncomeSimulator.vue')
);
Vue.component(
    'plane-examples-carousel',
    require('./components/PlaneExamplesCarousel.vue')
);

// End Other



// WEBPACK FOOTER //
// ./resources/assets/js/components.js